const config = window.AbdelmegedTheme || {};
const storageKey = config.storageKeys?.reactions || 'abdelmeged_reactions';

const read = () => {
  try {
    const value = JSON.parse(localStorage.getItem(storageKey) || '{}');

    return value && typeof value === 'object' ? value : {};
  } catch {
    return {};
  }
};

const write = (state) => {
  try {
    localStorage.setItem(storageKey, JSON.stringify(state));
  } catch {
    // Local storage may be unavailable in private contexts.
  }
};

const keyFor = (contentId, type) => `${contentId}:${type}`;

const has = (contentId, type) => Boolean(read()[keyFor(contentId, type)]);

const set = (contentId, type, active) => {
  const state = read();
  const key = keyFor(contentId, type);

  if (active) {
    state[key] = true;
  } else {
    delete state[key];
  }

  write(state);
};

window.AbdelmegedLikeStore = {
  has,
  set,
  read,
};
